import { useMemo, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { RECORD_TYPE_CHECK, RECORD_TYPE_DOCUMENT } from '@constants/annotations'
import ParseAPI from '@api/ParseAPI'
import { createQueryString } from '@utils'

const statusKeysMap = {
    [RECORD_TYPE_CHECK]: 'status',
    [RECORD_TYPE_DOCUMENT]: 'reviewStatus',
}

const baseUrlsMap = {
    [RECORD_TYPE_CHECK]: 'checks',
    [RECORD_TYPE_DOCUMENT]: 'document',
}

const urlParamsMap = {
    [RECORD_TYPE_CHECK]: {
        withAnnotations: true,
        withAnnotationLabels: true,
    },
    [RECORD_TYPE_DOCUMENT]: {},
}

const redirectUrlsMap = {
    [RECORD_TYPE_CHECK]: '/partners/checks',
    [RECORD_TYPE_DOCUMENT]: '/partners/documents',
}

export const usePartnersAutoReviewStatus = (recordType, recordId, setRecord) => {
    
    const navigate = useNavigate()
    
    const baseUrl = useMemo(() => baseUrlsMap[recordType], [recordType])
    const statusKey = useMemo(() => statusKeysMap[recordType], [recordType])
    const redirectUrl = useMemo(() => redirectUrlsMap[recordType], [recordType])
    
    useEffect(() => {
        
        if (!recordId) return
        
        const fn = async () => {
            
            try {
                
                // Update the record to show it's in review
                await ParseAPI.put(`/${baseUrl}/review/${recordId}`, {
                    [statusKey]: 'review_in_progress',
                })
                
                const params = createQueryString({
                    ...urlParamsMap[recordType],
                    offset: 0,
                    limit: 100,
                })
                
                const res = await ParseAPI.get(`/${baseUrl}/${recordId}${params}`)
                
                setRecord(res.data)
                
            } catch (e) {
                
                // @todo show error
                console.error('get doc by id', e)
                
                // Record doesn't exist
                if (e.response.status === 404)
                    navigate(redirectUrl)
                
            }
            
        }
        
        fn()
        
    }, [recordType, recordId, setRecord])
    
    useEffect(() => {
        
        const args = { recordType, recordId, setRecord }
        
        Object.keys(args).forEach(it => {
            if (!args[it])
                console.warn(`usePartnersAutoReviewStatus: missing arg "${it}"`)
        })
        
    }, [recordType, recordId, setRecord])
    
}
